export enum tokenTypes {
    userToken = "userToken",
    publicToken = "publicToken",
}
